import { Placement } from '@popperjs/core'
import { Tooltip } from '@positivote/design-system/components/Tooltip'
import { useTheme } from '@positivote/design-system/hooks'
import { AlertIcon } from '@positivote/design-system/icons/Alert'
import { CheckCircleIcon } from '@positivote/design-system/icons/CheckCircle'
import { Breakpoint } from '@positivote/design-system/theme'
import { osName, osVersion } from 'react-device-detect'

import { i18n } from '@/common/i18n'

import { AccordionRequirements } from './AccordionRequirements'

export interface AccordionOperationalSystemProps {
  operatingSystems:
    | {
        name: string
        minimumVersion: number
        warningMsg: string
        recommendedSystem: boolean
      }
    | undefined
  isLoading: boolean
}

export function AccordionOperationalSystem({
  isLoading,
  operatingSystems
}: AccordionOperationalSystemProps): JSX.Element {
  const { breakpoint } = useTheme()

  const tooltipPlacement: Placement = breakpoint >= Breakpoint.lg ? 'right' : 'left'

  return (
    <AccordionRequirements
      requirementsProps={{
        title: i18n().modules.requirements.components.accordionOperationalSystem.title,
        descriptions: [
          {
            key: 'operationalSystem',
            label: i18n().modules.requirements.components.accordionOperationalSystem.type,
            value:
              osName === 'none' ? i18n().modules.requirements.pages.details.errorMessage : osName,
            icon: <CheckCircleIcon fill="$success" />
          },
          {
            key: 'operationalSystemVersion',
            label: i18n().modules.requirements.components.accordionOperationalSystem.version,
            value:
              osVersion === 'none'
                ? i18n().modules.requirements.pages.details.errorMessage
                : osVersion === '10' && osName === 'Windows'
                  ? '10 ou superior'
                  : osVersion,
            icon:
              osVersion === 'none' ? (
                <Tooltip
                  label={i18n().modules.requirements.pages.details.errorMessage}
                  placement={tooltipPlacement}
                  arrow
                >
                  <AlertIcon fill="$critical" />
                </Tooltip>
              ) : Number(osVersion) >= Number(operatingSystems?.minimumVersion) ? (
                <CheckCircleIcon fill="$success" />
              ) : (
                <Tooltip
                  label={
                    operatingSystems?.warningMsg ??
                    i18n().modules.requirements.components.accordionOperationalSystem.tooltip
                      .incompatibleSystemVersionMessage
                  }
                  placement={tooltipPlacement}
                  arrow
                >
                  <AlertIcon fill="$warning" />
                </Tooltip>
              )
          }
        ]
      }}
      isLoading={isLoading}
    />
  )
}
